import {feeRateDangCiDic, getHasFeeRateBySettleByRate} from '@/util/settleUtils'
import {getInsureTypesString} from '@/util/insureTypesUtils'
import {dicSettleType} from '@/const/dic/settle'

//后端---  基础费率
export const rateCustomListOption = (safe) => {
	return {
		addBtn: false,
		card: true,
		stripe: true,
		border: true,
		editBtn: false,
		delBtn: false,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 180,
		gutter: 20,
		labelWidth: 120,
		searchMenuSpan: 6,
		column: [
			{
				label: '名称',
				prop: 'name',
				search: true,
				searchSpan: 6,
				searchOrder: 1,
				fixed: true,
			},
			{
				label: '创建时间',
				prop: 'createdAt',
				type: 'date',
				searchRange: true,
				search: true,
				searchOrder: 4,
				searchSpan: 7,
				valueFormat: 'yyyy-MM-dd',
			},
			{
				label: '修改时间',
				prop: 'updatedAt',
				type: 'datetime',
			},
			// {
			//     label: '状态',
			//     prop: 'status',
			//     type: 'select',
			//     hide: true,
			//     search: true,
			//     searchSpan: 5,
			//     searchOrder: 2,
			//     dicData: [
			//         {
			//             label: '全部',
			//             value: ''
			//         },
			//         {
			//             label: '关',
			//             value: 'OFF'
			//         },
			//         {
			//             label: '开',
			//             value: 'ON'
			//         }
			//     ]
			// },
			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				width: 180,
			},
		],
	}
}

export const rateCustomFormOption = {
	submitBtn: false,
	emptyBtn: false,
	gutter: 40,
	labelWidth: 110,
	column: [
		{
			label: '规则名称',
			prop: 'name',
			row: true,
			span: 19,
			maxlength: 40,
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请输入规则名称',
				},
			],
			disabled: false,
		},
		// , {
		//     label: '有效时间',
		//     prop: 'eTime',
		//     span: 19,
		//     type: 'daterange',
		//     rules: [
		//         {
		//             required: true,
		//             trigger: 'blur',
		//             message: '请选择有效时间'
		//         }
		//     ],
		//     format: 'yyyy-MM-dd HH:mm:ss',
		//     valueFormat: 'yyyy-MM-dd HH:mm:ss',
		//     defaultTime: ['00:00:00', '23:59:59'],
		//     pickerOptions: {
		//         disabledDate(time) {
		//             return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
		//         }
		//     }
		// },

		{
			label: '费率设置',
			prop: 'ruleItems',
			labelslot: true,
			formslot: true,
			span: 24,
		},
		{
			label: '适用渠道',
			prop: 'channelIds',
			span: 21,
			row: true,
		},
		{
			label: '渠道默认添加',
			prop: 'checked',
			type: 'switch',
			value: 0,
			dicData: [
				{
					label: '关闭',
					value: 0,
				},
				{
					label: '开启',
					value: 1,
				},
			],
		},
		{
			label: '备注',
			prop: 'remark',
			row: true,
			type: 'textarea',
			span: 19,
			showWordLimit: true,
			maxlength: 200,
			minRows: 3,
			maxRows: 5,
			display: true,
		},
		{
			label: '状态',
			prop: 'status',
			type: 'switch',
			value: 'ON',
			display: false,
			dicData: [
				{
					label: '',
					value: 'OFF',
				},
				{
					label: '',
					value: 'ON',
				},
			],
			labelslot: true,
		},
	],
}

export const rateInsureOption = {
	align: 'center',
	stripe: true,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	header: false,
	column: [
		{
			label: '名称',
			prop: 'insureName',
		},
		{
			label: '基础费率',
			prop: 'basicFeeRate',
			formatter: ({basicFeeRate}) => {
				return `${basicFeeRate}%`
			},
		},
		{
			label: '旧产品ID',
			prop: 'productIds',
			formatter: ({productIds}) => {
				return productIds ? productIds : '--'
			},
		},
		{
			label: '附加费率',
			prop: 'additionalFeeRate',
			formatter: ({additionalFeeRate}) => {
				return `${additionalFeeRate}%`
			},
		},
		{
			label: '生效时间',
			prop: 'effectiveTime',
			formatter: ({eTime}) => {
				return eTime[0]
			},
		},
		{
			label: '失效时间',
			prop: 'expireTime',
			formatter: ({eTime}) => {
				return eTime[1]
			},
		},
	],
}

//------------------------奖励规则------------------------------

//后端奖励费率
export const rateAwardListOption = (safe) => {
	return {
		editBtn: false,
		delBtn: false,
		addBtn: false,
		card: true,
		stripe: true,
		border: true,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 180,
		gutter: 20,
		searchMenuSpan: 6,
		column: [
			{
				label: '名称',
				prop: 'name',
				search: true,
				searchOrder: 1,
				fixed: true,
			},
			{
				label: '险种',
				prop: 'insureTypes',
				type: 'select',
				dicData: getInsureTypesString(),
				width: 160,
				search: true,
				searchOrder: 2,
				fixed: true,
				multiple: true,
				dataType: 'string',
			},

			{
				label: '达标档次',
				prop: 'feeRatePercent',
				formatter: (resData = {}) => {
					let {feeRatePercent = 0, insureTypes = 0} = resData
					return getHasFeeRateBySettleByRate(feeRatePercent, insureTypes)
				},
			},
			{
				label: '奖励档次',
				prop: 'countRatePercent',
				formatter: (resData = {}) => {
					let {countRatePercent = 0, insureTypes = 0} = resData
					return getHasFeeRateBySettleByRate(countRatePercent, insureTypes)
				},
			},
			//奖励规则增加字段 recoveryStrategy：追回策略，NO不追回，ALL全部，SURRENDER退保，REDUCE批减
			{
				label: '奖励追回',
				prop: 'recoveryStrategy',
				search: true,
				type: 'select',
				dicData: [
					{
						label: '不追回',
						value: 'NO',
					},
					{
						label: '全部追回',
						value: 'ALL',
					},
					{
						label: '退保追回',
						value: 'SURRENDER',
					},
					{
						label: '批减追回',
						value: 'REDUCE',
					},
				],
			},
			{
				label: '生效时间',
				prop: 'countStartTime',
			},
			{
				label: '到期时间',
				prop: 'countEndTime',
			},
			// {
			//     label: '有效时间',
			//     prop: 'countStartTime',
			//     formatter: ({countStartTime, countEndTime}) => {
			//         return `${countStartTime}-${countEndTime}`
			//     }
			// },
			{
				label: '类型',
				prop: 'countType',
				type: 'select',
				dicData: [
					{
						label: '单一保单',
						value: 'SINGLE',
					},
					{
						label: '全部保单',
						value: 'SUM',
					},
				],
			},
			{
				label: '创建时间',
				prop: 'createdAt',
				type: 'date',
				searchSpan: 6,
				searchRange: true,
				search: true,
				searchOrder: 5,
				valueFormat: 'yyyy-MM-dd',
			},
			{
				label: '修改时间',
				prop: 'updatedAt',
				type: 'datetime',
			},
			// {
			//     label: '状态',
			//     prop: 'status',
			//     type: 'select',
			//     search: true,
			//     searchOrder: 3,
			//     dicData: [
			//         {
			//             label: '启用',
			//             value: 'ON'
			//         },
			//         {
			//             label: '停用',
			//             value: 'OFF'
			//         }
			//     ]
			// },
			{
				label: '备注',
				prop: 'remark',
				type: 'textarea',
				width: 180,
				maxlength: 200,
			},
		],
	}
}

//奖励规则
export const rateAwardFormOption = {
	submitBtn: false,
	emptyBtn: false,
	gutter: 40,
	labelWidth: 120,
	column: [
		{
			label: '规则名称',
			prop: 'name',
			row: true,
			span: 19,
			maxlength: 40,
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请输入规则名称',
				},
			],
			disabled: false,
		},
		//   {
		//   label: '险种',
		//   prop: 'insureType',
		//   type: 'select',
		//   span: 19,
		//   dicData: rateDicData,
		//   props: {
		//     label: 'insureName',
		//     value: 'insureType'
		//   },
		//   rules: [
		//     {
		//       required: true,
		//       trigger: 'change',
		//       message: '请选择险种'
		//     }
		//   ],
		//   control: (val, form) => {
		//     if (val === 8 || val === 15) {
		//       return {
		//         feeRatePercent: {
		//           display: true
		//         },
		//         countRatePercent: {
		//           display: true
		//         }
		//       }
		//     } else {
		//       return {
		//         feeRatePercent: {
		//           display: false
		//         },
		//         countRatePercent: {
		//           display: false
		//         }
		//       }
		//     }
		//   }
		// },
		// {
		//   label: '险种（可多选）',
		//   prop: 'insureTypes',
		//   type: 'select',
		//   multiple: true,
		//   span: 19,
		//   dicData: getInsureTypesString(),
		//   rules: [
		//     {
		//       required: true,
		//       trigger: 'change',
		//       message: '请选择险种',
		//     },
		//   ],
		//   dataType: 'string',
		// },
		// {
		//   label: '产品编号',
		//   prop: 'productIds',
		//   span: 19,
		// },
		{
			label: '结算开启时间',
			prop: 'settleStartTime',
			type: 'date',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			row: true,
			span: 19,
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请选择 结算开启时间',
				},
			],
		},
		{
			label: '奖励是否兼得',
			prop: 'awardCombine',
			type: 'select',
			span: 19,
			dicData: [
				{
					label: '是',
					value: true,
				},
				{
					label: '否',
					value: false,
				},
			],
			rules: [
				{
					required: true,
					trigger: 'change',
					message: '请选择奖励是否兼得',
				},
			],
		},
		{
			label: '奖励模式',
			prop: 'countType',
			type: 'select',
			row: true,
			span: 19,
			rules: [
				{
					required: true,
					trigger: 'change',
					message: '请选择奖励模式',
				},
			],
			dicData: [
				{
					label: '单一保单',
					value: 'SINGLE',
				},
				{
					label: '全部保单',
					value: 'SUM',
				},
			],
		},

		{
			label: '奖励方案',
			prop: 'ruleItems',
			formslot: true,
			row: true,
			span: 21,
			dataType: 'string',
			// rules: [
			//     {
			//         required: true,
			//         trigger: 'change',
			//         message: ' '
			//     }
			// ]
		},
		//奖励规则增加字段 recoveryStrategy：追回策略，NO不追回，ALL全部，SURRENDER退保，REDUCE批减
		{
			label: '奖励追回',
			prop: 'recoveryStrategy',
			type: 'radio',
			row: true,
			span: 19,
			dicData: [
				{
					label: '不追回',
					value: 'NO',
				},
				{
					label: '全部追回',
					value: 'ALL',
				},
				{
					label: '退保追回',
					value: 'SURRENDER',
				},
				{
					label: '批减追回',
					value: 'REDUCE',
				},
			],
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请选择奖励追回',
				},
			],
		},

		{
			label: '适用渠道',
			prop: 'channelIds',
			span: 21,
			row: true,
			// rules: [
			//     {
			//         required: true,
			//         trigger: 'change',
			//         message: ' '
			//     }
			// ]
		},
		{
			label: '有效期',
			prop: 'validTime',
			type: 'daterange',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
			format: 'yyyy-MM-dd HH:mm:ss',
			defaultTime: ['00:00:00', '23:59:59'],
			startPlaceholder: '选择开始时间',
			endPlaceholder: '选择结束时间',
			rangeSeparator: '至',
			row: true,
			span: 19,
			rules: [
				{
					required: true,
					trigger: 'blur',
					message: '请选择有效期',
				},
			],
		},
		{
			label: '渠道默认添加',
			prop: 'checked',
			type: 'switch',
			value: 1,
			dicData: [
				{
					label: '关闭',
					value: 0,
				},
				{
					label: '开启',
					value: 1,
				},
			],
		},
		{
			label: '备注',
			prop: 'remark',
			row: true,
			type: 'textarea',
			span: 19,
			showWordLimit: true,
			maxlength: 200,
			minRows: 3,
			maxRows: 5,
			display: true,
		},
		{
			label: '状态',
			prop: 'status',
			type: 'switch',
			value: 'ON',
			display: false,
			dicData: [
				{
					label: '',
					value: 'OFF',
				},
				{
					label: '',
					value: 'ON',
				},
			],
			labelslot: true,
		},
	],
}

//奖励 确认表格
export const awardInsureOption = {
	align: 'center',
	stripe: true,
	border: true,
	menu: false,
	addBtn: false,
	refreshBtn: false,
	columnBtn: false,
	header: false,
	defaultSort: {
		prop: 'moneyThreshold',
		order: 'ascending',
	},
	column: [
		//   {
		//   label: '规则',
		//   prop: 'insureName',
		//
		// },
		{
			label: '险种（可多选）',
			prop: 'insureTypes',
			type: 'select',
			multiple: true,
			span: 19,
			dicData: getInsureTypesString(),
			rules: [
				{
					required: true,
					trigger: 'change',
					message: '请选择险种',
				},
			],
			dataType: 'string',
		},
		{
			label: '旧产品编号',
			prop: 'productIds',
			span: 19,
			formatter: ({productIds = ''}) => {
				return productIds ? productIds : '--'
			},
		},
		{
			label: '达标档次',
			prop: 'feeRatePercent',
			span: 19,
			display: false,
			formatter: ({feeRatePercent = -1, insureTypes = ''}) => {
				if (feeRatePercent === -1) {
					return '--'
				}
				let tempDic = feeRateDangCiDic[insureTypes + ''] || []
				let tempChoiceData = tempDic.find((item) => item.value + '' === feeRatePercent + '') || null
				if (tempChoiceData) {
					return tempChoiceData.label
				}
				return '--'
			},
		},
		{
			label: '奖励档次',
			prop: 'countRatePercent',
			span: 19,
			display: false,
			formatter: ({countRatePercent = -1, insureTypes = ''}) => {
				if (countRatePercent === -1) {
					return '--'
				}
				let tempDic = feeRateDangCiDic[insureTypes + ''] || []
				let tempChoiceData = tempDic.find((item) => item.value + '' === countRatePercent + '') || null
				if (tempChoiceData) {
					return tempChoiceData.label
				}
				return '--'
			},
		},
		{
			label: '达标条件(元)',
			prop: 'moneyThreshold',
			sortable: true,
		},
		{
			label: '奖励费率',
			prop: 'awardRate',
			formatter: ({awardRate}) => {
				return `${awardRate}%`
			},
			sortable: true,
		},
	],
}

//奖励 确认表格
export const settlePlanList = (safe) => {
	return {
		addBtn: false,
		card: true,
		stripe: true,
		border: true,
		editBtn: false,
		delBtn: false,
		menu: false,
		excelBtn: false,
		align: 'center',
		menuAlign: 'center',
		column: [
			{
				label: '月份',
				prop: 'month123',
				search: true,
				hide: true,
				type: 'date',
				format: 'yyyyMM',
				valueFormat: 'yyyyMM',
			},
			{
				label: '月份',
				prop: 'month',
			},
			{
				label: '周期',
				prop: 'serial',
				search: true,
				type: 'select',
				dicData: [
					{
						label: '上半月',
						value: 1,
					},
					{
						label: '下半月',
						value: 2,
					},
				],
			},
			{
				label: '渠道名称',
				prop: 'channelName',
				search: true,
			},
			{
				label: '费用（元）',
				prop: 'fee',
			},
			{
				label: '实发费用（元）',
				prop: 'feeReal',
			},
			{
				label: '税费（元）',
				prop: 'tax',
			},
			{
				label: '联系人',
				prop: 'userName',
				search: true,
			},
			{
				label: '手机号',
				prop: 'mobile',
				search: true,
			},
			{
				label: '身份证号',
				prop: 'idNo',
				search: true,
			},
			{
				label: '银行名称',
				prop: 'bankName',
				search: true,
			},
			{
				label: '银行卡号',
				prop: 'cardNo',
				search: true,
			},
			{
				label: '备注',
				prop: 'statusDesc',
			},
		],
	}
}

//奖励 确认表格
export const settlePlanDetailList = (safe) => {
	return {
		addBtn: false,
		card: true,
		stripe: true,
		border: true,
		editBtn: false,
		delBtn: false,
		menu: false,
		excelBtn: true,
		align: 'center',
		menuAlign: 'center',
		column: [
			{
				label: '月份',
				prop: 'month123',
				search: true,
				hide: true,
				type: 'date',
				format: 'yyyyMM',
				valueFormat: 'yyyyMM',
			},
			{
				label: '月份',
				prop: 'month',
			},
			{
				label: '周期',
				prop: 'serial',
				search: true,
				type: 'select',
				dicData: [
					{
						label: '上半月',
						value: 1,
					},
					{
						label: '下半月',
						value: 2,
					},
				],
			},

			{
				label: '结算费用（元）',
				prop: 'fee',
				width: 110,
			},
			// 含税费用 feeTax，实发费用 feeReal， 税费 tax
			{
				label: '含税费用（元）',
				prop: 'feeTax',
				width: 110,
			},
			{
				label: '实发费用（元）',
				prop: 'feeReal',
				width: 110,
			},
			{
				label: '税费（元）',
				prop: 'tax',
				width: 90,
			},
			{
				label: '联系人',
				prop: 'userName',
			},
			{
				label: '手机号',
				prop: 'mobile',
				search: true,
			},
			{
				label: '身份证号',
				prop: 'idNo',
				search: true,
			},
			{
				label: '银行名称',
				prop: 'bankName',
				search: true,
			},
			{
				label: '银行卡号',
				prop: 'cardNo',
				search: true,
			},
			{
				label: '备注',
				prop: 'statusDesc',
			},
		],
	}
}

//预警
export const settleAlertsOption = (safe) => {
	return {
		addBtn: false,
		card: true,
		stripe: true,
		border: true,
		editBtn: false,
		delBtn: false,
		excelBtn: true,
		refreshBtn: false,
		align: 'center',
		menuAlign: 'center',
		menuWidth: 100,
		searchLabelWidth: 120,
		gridBtn: false,
		column: [
			{
				label: '渠道名称',
				prop: 'channelId',
				search: true,
				bind: 'channel.name',
			},
			{
				label: '结算方式',
				prop: 'settleType',
				type: 'select',
				search: true,
				dicData: dicSettleType,
			},
			{
				label: '业务跟进人',
				prop: 'followId',
				type: 'select',
				filterable: true,
				bind: 'channel.followId',
				search: true,
				props: {
					label: 'name',
					value: 'id',
				},
				dicUrl: '/dist/distChannel/follow/listContact',
			},
			//当期可结算费用totalFee
			{
				label: '当期可结算费用（元）',
				prop: 'totalFee',
			},
			//当前能结算费用
			{
				label: '当前能结算费用（元）',
				prop: 'feeReal',
			},
			{
				label: '超额金额（元）',
				prop: 'remainFee',
				html: true,
			},
			{
				label: '更新时间',
				prop: 'updatedAt',
			},
		],
	}
}
